PLAN_ID_BULK_GIFT_ANNUAL